import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { CookiesProvider } from 'react-cookie';
import { createBrowserHistory, History } from 'history';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { AppConfigProvider } from 'config/provider';
import { AppLoggerProvider } from 'App/components/utils/providers/AppLoggerProvider';
import { Loader } from 'App/layout/Loader';
import { AppRoot } from 'App/root/context';
import { AppProductsProvider } from 'App/components/utils/providers/AppProductProvider';
import { I18NextProvider } from 'App/components/utils/providers/I18NextProvider';
import { appI18NextInitOptions, appI18NextPreInitCallback } from 'i18n';
import { RealServiceProviders, MockedServiceProviders } from 'App/providers/ServiceProviders';

export const history: History = createBrowserHistory();

let previousPathname: string = '';
history.listen( ( location ) => {
  if ( !previousPathname || previousPathname !== location.pathname ) {
    analytics?.page();
    previousPathname = location.pathname;
  }
} );

const queryClient = new QueryClient();

const app: JSX.Element = (
  <AppConfigProvider>
    <AppLoggerProvider name="logger">
      <I18NextProvider preInit={ appI18NextPreInitCallback } initOptions={ appI18NextInitOptions }>
        <Suspense fallback={ <Loader /> }>
          <QueryClientProvider client={ queryClient }>
            <AppProductsProvider>
              <Router history={ history }>
                <RealServiceProviders>
                  <MockedServiceProviders>
                    <CookiesProvider>
                      <AppRoot>
                        <App />
                      </AppRoot>
                    </CookiesProvider>
                  </MockedServiceProviders>
                </RealServiceProviders>
              </Router>
            </AppProductsProvider>
          </QueryClientProvider>
        </Suspense>
      </I18NextProvider>
    </AppLoggerProvider>
  </AppConfigProvider>
);

ReactDOM.render( app, document.getElementById( 'root' ) );

// If you want your app to work offline and load faster, you can change
// Unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
